// ======================================================================
// File Name       : ContentDistributionListContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React from 'react';
import { connect } from 'react-redux';
import DistributionServiceSearch from '../../components/contentDistribution/DistributionServiceSearch';
import DistributionServiceList from '../../components/contentDistribution/DistributionServiceList';
import { distributionServiceSearch, sendSyncContents, sendSyncCourses } from '../../actions/ContentDistributionAction';
import { DRILL, VIDEO, DOCUMENT, LINK, COURSE } from '../../constants/ContentDistributionConstant';
import { getContentDistributionTypeValue } from '../../utils/ContentDistributionUtils';
import { RETURN_MAX_NUM } from '../../constants/index';
import Header from '../../components/Header';
import MessageSearch from '../../components/MessageSearch';
import * as Path from '../../constants/PathConstants';
import * as actionType from '../../constants/actionTypes/page';
import { hideLoading, showLoading } from '../../utils/PageUtils';

class ContentDistributionListContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      showModal: false,
      distributionServiceSearchInfo: {
        serviceName: '',
        enterpriseName: '',
        distributionType: '',
        distributionServiceSortType: -1, // default not sort
        ascendingDescendingSort: null, // default value
        startPosition: 0, // default value
      },
      // Click search button
      currentSearch: {
        distributionServiceSortType: -1,
        ascendingDescendingSort: null,
        startPosition: 0,
      },
      returnMaxNum: RETURN_MAX_NUM, // default value
      distributionServiceListInfo: null,
      isAllowShowSearchMessage: false,
      isInit: true,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.dismissMessage = this.dismissMessage.bind(this);
    this.onSearchBtn = this.onSearchBtn.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    // Step 11.0.0 START
    this.doSyncContents = this.doSyncContents.bind(this);
    this.doSyncCourses = this.doSyncCourses.bind(this);
    // Step 11.0.0 END
  }

  componentWillMount() {
    if (this.props.parentPath === Path.CONTENT_DISTRIBUTION_LIST) {
      this.setState({
        ...this.state,
        currentSearch: this.props.searchCondition,
        distributionServiceSearchInfo: this.props.searchCondition,
        isInit: true,
      });
    }
  }

  componentDidMount() {
    this.getDistributionServiceList();
  }

  componentWillReceiveProps(nextProps) {
    const { contentDistribution } = nextProps;
    const { distributionServiceListInfo } = contentDistribution;
    this.setState({
      distributionServiceListInfo,
    });
  }

  componentWillUnmount() {
    const searchCondition = this.state.currentSearch;
    searchCondition.startPosition = this.state.distributionServiceSearchInfo.startPosition;
    searchCondition.distributionServiceSortType = this.state.distributionServiceSearchInfo.distributionServiceSortType;
    searchCondition.ascendingDescendingSort = this.state.distributionServiceSearchInfo.ascendingDescendingSort;
    this.props.dispatch({
      type: actionType.SAVE_SEARCH_CONDITION,
      parentPath: Path.CONTENT_DISTRIBUTION_LIST,
      searchCondition,
    });
  }
  /**
   * Get content distribution list when click button search
   */

  onSearchBtn() {
    const distributionServiceSearchInfo = {
      ...this.state.distributionServiceSearchInfo,
      distributionServiceSortType: null,
      ascendingDescendingSort: 0,
      startPosition: 0,
    };
    const currentSearch = {
      ...this.state.distributionServiceSearchInfo,
      ...(this.state.currentSearch = this.state.distributionServiceSearchInfo),
    };
    this.setState(
      {
        distributionServiceSearchInfo,
        currentSearch,
        isAllowShowSearchMessage: true,
        isInit: false,
      }, () => {
      this.getDistributionServiceList();
    });
  }

  /**
   * Get content distribution service list
   *
   */
  getDistributionServiceList() {
    const auth = this.props.auth;
    const distributionType = this.state.distributionServiceSearchInfo.distributionType;
    const contentType = this.state.distributionServiceSearchInfo.contentDistributionType;
    const param = {
      searchInfo: {
        serviceName: this.state.distributionServiceSearchInfo.serviceName || undefined,
        enterpriseName: this.state.distributionServiceSearchInfo.enterpriseName || undefined,
        distributionType: !isNaN(distributionType) && distributionType !== '' ? parseInt(distributionType, 10) : undefined,
        drillDistributionExistence: getContentDistributionTypeValue(DRILL, contentType) ? 1 : undefined,
        videoDistributionExistence: getContentDistributionTypeValue(VIDEO, contentType) ? 1 : undefined,
        documentDistributionExistence: getContentDistributionTypeValue(DOCUMENT, contentType) ? 1 : undefined,
        linkDistributionExistence: getContentDistributionTypeValue(LINK, contentType) ? 1 : undefined,
        distributionServiceSortType: this.state.distributionServiceSearchInfo.distributionServiceSortType < 0 ? undefined : this.state.distributionServiceSearchInfo.distributionServiceSortType,
        ascendingDescendingSort: this.state.distributionServiceSearchInfo.ascendingDescendingSort || 0,
        startPosition: this.state.distributionServiceSearchInfo.startPosition || 0,
        returnMaxNum: this.state.returnMaxNum,
      },
    };

    this.props.dispatch(distributionServiceSearch(param, auth)).then(() => {
      if (!this.state.isInit) {
        this.setState({ isAllowShowSearchMessage: true });
      }
    });
  }

  /**
     * handle change for user input
     * @param {*} event
     */
  // If distribution type is COURSE, reset and hide content distribution type field
  handleChange(event) {
    const { name, value } = event.target;
    if (name === 'distributionType') {
      let distributionServiceSearchInfo = {};
      const checkValue = parseInt(value, 10);
      if (checkValue === COURSE || isNaN(checkValue)) {
        distributionServiceSearchInfo = {
          ...this.state.distributionServiceSearchInfo,
          ...{ [name]: checkValue },
          ...{ contentDistributionType: '' },
        };
      } else {
        distributionServiceSearchInfo = {
          ...this.state.distributionServiceSearchInfo,
          ...{ [name]: value },
        };
      }
      this.setState({ distributionServiceSearchInfo });
    } else {
      const distributionServiceSearchInfo = {
        ...this.state.distributionServiceSearchInfo,
        ...{ [name]: value } };
      this.setState({ distributionServiceSearchInfo });
    }
  }

  /**
     * Pagination
     * @param {*} startPosition
     */
  getStartEndData(startPosition) {
    const distributionServiceSearchInfo = {
      ...this.state.distributionServiceSearchInfo,
      ...{ startPosition },
    };
    this.setState(
      {
        distributionServiceSearchInfo,
      }, () => { this.getDistributionServiceList(); },
    );
  }

  /**
     * handle sorting data
     * @param {*} row
     */
  handleSortState(row) {
    const { distributionServiceSearchInfo } = this.state;
    distributionServiceSearchInfo.ascendingDescendingSort = row.sortState;
    distributionServiceSearchInfo.distributionServiceSortType = row.sortBy;
    this.setState(
      {
        distributionServiceSearchInfo,
      },
      () => {
        this.getDistributionServiceList();
      },
    );
  }

  dismissMessage() {
    this.setState({ isAllowShowSearchMessage: false });
  }

  handleMouseEnter(index) {
    this.setState({
      hoverIndex: index,
    });
  }

  handleMouseLeave() {
    this.setState({
      hoverIndex: undefined,
    });
  }

  // Step 11.0.0 START
  doSyncContents() {
    const { dispatch } = this.props;
    dispatch(showLoading());
    dispatch(sendSyncContents()).then(() => dispatch(hideLoading()));
  }

  doSyncCourses() {
    const { dispatch } = this.props;
    dispatch(showLoading());
    dispatch(sendSyncCourses()).then(() => dispatch(hideLoading()));
  }
  // Step 11.0.0 END

  /**
   * Render function of component
   */
  render() {
    const { hoverIndex } = this.state;
    const recordNum = this.state.distributionServiceListInfo ? this.state.distributionServiceListInfo.recordNum : 0;
    const distributionServiceList = this.state.distributionServiceListInfo ? this.state.distributionServiceListInfo.distributionServiceList : [];
    return (
      <div>
        <MessageSearch
          recordNum={recordNum}
          resultList={distributionServiceList}
          isAllowShowSearchMessage={this.state.isAllowShowSearchMessage}
          dismissMessage={this.dismissMessage}
        />
        <Header name="コンテンツ配布先情報の一覧" />
        <DistributionServiceSearch
          {...this.state.distributionServiceSearchInfo}
          handleInputChange={this.handleChange}
          onSearchBtnClick={this.onSearchBtn}
          doSyncContents={this.doSyncContents}
          doSyncCourses={this.doSyncCourses}
        />
        <DistributionServiceList
          distributionServiceListInfo={this.state.distributionServiceListInfo}
          handleSortState={this.handleSortState}
          dataSort={this.state.distributionServiceSearchInfo}
          recordNum={recordNum}
          startPosition={this.state.distributionServiceSearchInfo.startPosition}
          getStartEndData={this.getStartEndData}
          handleMouseEnter={this.handleMouseEnter}
          handleMouseLeave={this.handleMouseLeave}
          hoverIndex={hoverIndex}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { parentPath, searchCondition } = state.page;
  return ({
    ...{ contentDistribution: state.contentDistribution,
      auth: state.authed.authedUser },
    parentPath,
    searchCondition,
  });
};

export default connect(mapStateToProps)(ContentDistributionListContainer);
